import { deserialize, serialize, Constructor } from '@junte/serialize-ts';

import { DTO } from './dto';
import { Entity } from './entity';

export abstract class Mapper<E extends Entity, D extends DTO> {
  public abstract toDTO(model: E): D;
  public abstract toModel(dto: D): E;
}

export class Automapper<E extends Entity, D extends DTO> implements Mapper<E, D> {
  private constructor(private modelConstructor: Constructor<E>) {}

  public static create<E extends Entity>(modelConstructor: Constructor<E>): Automapper<E, DTO> {
    return new Automapper(modelConstructor);
  }

  public toDTO(model: E): D {
    return serialize(model) as D;
  }

  public toModel(dto: D): E {
    return deserialize(dto, this.modelConstructor);
  }
}
